var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5404_26854",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5404_26854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00059 10.0516L5.32559 13.7266C5.18809 13.8641 5.01309 13.9328 4.80059 13.9328C4.58809 13.9328 4.41309 13.8641 4.27559 13.7266C4.13809 13.5891 4.06934 13.4141 4.06934 13.2016C4.06934 12.9891 4.13809 12.8141 4.27559 12.6766L7.95059 9.00156L4.27559 5.32656C4.13809 5.18906 4.06934 5.01406 4.06934 4.80156C4.06934 4.58906 4.13809 4.41406 4.27559 4.27656C4.41309 4.13906 4.58809 4.07031 4.80059 4.07031C5.01309 4.07031 5.18809 4.13906 5.32559 4.27656L9.00059 7.95156L12.6756 4.27656C12.8131 4.13906 12.9881 4.07031 13.2006 4.07031C13.4131 4.07031 13.5881 4.13906 13.7256 4.27656C13.8631 4.41406 13.9318 4.58906 13.9318 4.80156C13.9318 5.01406 13.8631 5.18906 13.7256 5.32656L10.0506 9.00156L13.7256 12.6766C13.8631 12.8141 13.9318 12.9891 13.9318 13.2016C13.9318 13.4141 13.8631 13.5891 13.7256 13.7266C13.5881 13.8641 13.4131 13.9328 13.2006 13.9328C12.9881 13.9328 12.8131 13.8641 12.6756 13.7266L9.00059 10.0516Z",
    fill: "#0E3F51"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSvg);
export default __webpack_public_path__ + "static/media/CloseSvg.8282adf5.svg";
export { ForwardRef as ReactComponent };